export interface cv_TestArticle {
    C_TestArticle_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    IsSystemGenerated: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    TestArticle: string;
    Version: number;
}
